





















import {Component, Vue, Watch} from 'vue-property-decorator';
import Password from '../components/Password.vue';
import ErrorGroup from '../components/ErrorGroup.vue';
import Heading from '../components/Heading.vue';
import {Action} from 'vuex-class';
import {passwordStrengthCopy} from '@/helpers/validate-password';

@Component({
  components: {
    Password,
    ErrorGroup,
    Heading,
  },
})
export default class ChangePassword extends Vue {
  passwordStrengthCopy = passwordStrengthCopy;
  protected oldPassword: string = '';
  protected newPassword: string = '';
  protected isValidPassword: boolean = false;

  @Action('changePassword') protected changePasswordAction: any;

  protected handleSubmit() {
    this.changePasswordAction({
      oldPassword: this.oldPassword,
      newPassword: this.newPassword,
    });
  }

  @Watch('newPassword')
  private onModelChanged(value: string, oldValue: string) {
    this.isValidPassword = validatePassword(value);
  }
}
const validatePassword = (value: string): boolean => {
  return !!(value && hasMinChar(value) && hasNumber(value));
};
const hasMinChar = (value: string): boolean => value.length > 6;
const hasNumber = (value: string): boolean => /\d/.test(value);
